import React from 'react';

const LineBreaker = ({ text }) => {
    const lines = text.split('\n').flatMap((line) => (line.length > 0 ? line.trim() : []));
    return (
        <>
            {lines.map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ))}
        </>
    );
};

export default LineBreaker;
